/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function popupFreeSamples() {

  window[`closePopup-free-samples-popup`] = document.getElementById("popupclose-free-samples-popup");  
  window[`overlay-free-samples-popup`] = document.getElementById("overlay-free-samples-popup");                                                         
  window[`popup-free-samples-popup`] = document.getElementById("popup-free-samples-popup");                                                                                                               

  window[`overlay-free-samples-popup`].onclick = function() {
    window[`overlay-free-samples-popup`].className = '';
    window[`popup-free-samples-popup`].className = '';
  };

  window[`closePopup-free-samples-popup`].onclick = function() {
    window[`overlay-free-samples-popup`].className = '';
    window[`popup-free-samples-popup`].className = '';
  };

  window[`overlay-free-samples-popup`].className = 'show';
  window[`popup-free-samples-popup`].className = 'show';
};

function SampleAddToCart(e){

  var vid = $(e).data('vid');

  const result = fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      'id':vid,
      'quantity':1
    })
  }).then(response => {
    document.dispatchEvent(new CustomEvent('product:added', {
      bubbles: true,
      detail: {
        id: vid,
        quantity: parseInt(1)
      }
    }))
  })
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
  }));
  window[`overlay-free-samples-popup`].className = '';
  window[`popup-free-samples-popup`].className = '';
  return false;
} 

// Internal link removal
navLinkRemoval = function(e) {
  e.preventDefault();
  window.location.href = $(this).attr('data-url');
  console.log($(this).attr('data-url'));
}

var navLinks = document.getElementsByClassName('link-nav');
for (var i=0; i < navLinks.length; i++) {
  navLinks.item(i).onclick = navLinkRemoval;
}

document.addEventListener('quizKitAddToCartSuccess', function (e) {
  const customAddToCart = new CustomEvent("product:added", {
    bubbles: true,
    detail: { quantity: 1 }
  });
  
  document.dispatchEvent(customAddToCart)
}, false);